import React, { useEffect, useState } from "react";
import styled from "styled-components";
import api2 from "../../../../Component/axios_Interceptor/api2";
import { modalProps } from "../../../../Component/Interface/Modal";
import url from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView2,
  TitleArea,
} from "../../../../Component/style/common_style";
import api from "../../../../Component/axios_Interceptor/api";

const Product_list = ({
  visible,
  handleModal,
  setSearch_item,
}: modalProps & {
  setSearch_item: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [cnt, setCnt] = useState(0);
  const [list, setList] = useState<string[]>([]);
  const [search_word, setSearch_word] = useState("");

  const viewList = cnt > 20 ? list : new Array(20).fill("");

  const setting_search_word = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSearch_word(e.target.value);

  const get_product_name_list = async (search_value: string) => {
    try {
      const res = await api.get(url.Communication_url.product_name_list, {
        params: { search_value: search_value },
      });
      setList(res.data || []);
      setCnt(res.data.length || 0);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };
  useEffect(() => {
    if (visible) {
      get_product_name_list("");
    }
  }, [visible]);

  const search = () => {
    if (search_word.trim() === "") {
      return alert("품목명을 적어주세요.");
    }
    get_product_name_list(search_word);
  };
  const reset = () => {
    if (search_word.trim() !== "") {
      setSearch_word("");
      get_product_name_list("");
    }
  };
  const select_item = (data: string) => {
    if (data !== "") {
      setSearch_item(data);
      close();
    }
  };
  const close = () => handleModal();

  return (
    <ModalBox className="col" style={visible ? {} : { display: "none" }}>
      <TitleArea style={{ width: "100%", padding: "1rem" }}>
        <div>품목 선택</div>
        <Icon
          onClick={close}
          src={require("../../../../Image/ic_closeX.png")}
        />
      </TitleArea>

      <Header>
        <div className="idx">구분</div>
        <div className="name">품목명</div>
      </Header>

      <ScrollBox>
        {viewList.map((data, idx) => {
          return (
            <Row key={idx} style={idx === 0 ? { borderTop: 0 } : {}}>
              <div className="idx">{idx + 1}</div>
              <div
                className="name"
                onClick={() => select_item(data || list[idx] || "")}
              >
                {data || list[idx] || ""}
              </div>
            </Row>
          );
        })}
      </ScrollBox>

      <SearchArea>
        <input
          placeholder="품목검색"
          value={search_word}
          onChange={setting_search_word}
        />
        <CenterView className="btn" onClick={search}>
          검색
        </CenterView>
        <Icon
          className="reset"
          src={require("../../../../Image/ic_reset_black.png")}
          onClick={reset}
        />
      </SearchArea>
    </ModalBox>
  );
};

export default Product_list;

const ModalBox = styled(CenterView)`
  position: absolute;
  top: 0;
  margin-top: 1.5rem;
  box-sizing: border-box;
  width: 30rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
`;
const Header = styled(RowView2)`
  width: 100%;
  color: #757575;
  background-color: #f8f8f8;
  border: 1px solid #e8e8e8;
  div.idx {
    box-sizing: border-box;
    padding: 1rem 0;
    text-align: center;
    width: 3rem;
    border-right: 1px solid #e8e8e8;
  }
  div.name {
    padding: 1rem;
    flex: 1;
  }
`;
const ScrollBox = styled.div`
  width: 100%;
  height: 20rem;
  overflow-y: auto;
  overflow-x: hidden;
`;
const Row = styled(RowView2)`
  width: 100%;
  border-top: 1px solid #e8e8e8;
  cursor: pointer;
  div.idx {
    box-sizing: border-box;
    padding: 0.5rem 0;
    text-align: center;
    width: 3rem;
    border-right: 1px solid #e8e8e8;
  }
  div.name {
    padding: 0.5rem 1rem;
    flex: 1;
  }
  &:hover {
    background-color: #fafafa;
  }
`;
const SearchArea = styled(RowView2)`
  box-sizing: border-box;
  width: 100%;
  padding: 1rem;
  border-top: 1px solid #e8e8e8;
  div.btn {
    margin-left: 0.5rem;
    ${fontStyles.medium};
    text-align: center;
    color: white;
    background-color: #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
`;
